<template>
  <div id="about-ts-together">
    <!-- <v-container> -->
    <v-row class="text-center d-flex justify-center">
      <v-col class="mb-6" cols="10">
        <div class="py-12"></div>
        <h3 class="mb-6 display-1">
          È nata TechSoup Together.
          <br />Cos’è?
        </h3>

        <p class="font-weight-light title">
          TechSoup Together è il luogo dedicato agli operatori del Terzo Settore dove discutere, 
          <span class="font-weight-bold">testare e migliorare</span>  le proprie iniziative sociali. 
          <br >
          Una <span class="font-weight-bold">community di apprendimento</span>
           dove puoi amplificare le tue competenze professionali a partire dal confronto con storie ed esperienze di chi è sul campo. 
        </p>
      </v-col>
    </v-row>

    <div>
      <v-row class="align-center py-12">
        <v-col class="col-md-6 col-12">
          <div style="max-height: 100%">
            <v-img
              :src="require('@/assets/devices.png')"
              class="background-position: center center;"
              aspect-ratio="1.2"
              contain
            ></v-img>
          </div>
        </v-col>
        <v-col class="col-md-6 col-12">
          <div class="subheading text-left px-12">
            <h2 class="mb-2 body-2 primary--text">Un appuntamento fisso</h2>
            <div class="font-weight-normal headline mb-6">
              Ogni settimana impara <br> da chi fa meglio del bene.
            </div>
            <v-btn color="primary mb-6" class="uppercase" to="/signup" large>Inizia ora</v-btn>
            <!-- <p class="caption font-weight-light">
              15 giorni di prova gratuita. Se non è per te, disdici quando vuoi.
            </p> -->
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="align-center">
      <v-col class="col-md-5 col-12">
        <div class="subheading text-left px-12">
          <h2 class="mb-2 body-2 primary--text">Un dialogo continuo, contenuti sempre nuovi.</h2>
          <div class="font-weight-light headline mb-4">
            Chiedi, fai domande 
            e metti a tema quello che 
            più interessa a te. 
          </div>
          <p class="font-weight-light body-2 mb-6">
            Con la formula
            <span class="font-weight-regular">A</span>sk
            <span class="font-weight-regular">M</span>e
            <span class="font-weight-regular">A</span>nything interagisci
            direttamente con colleghi ed esperti del Terzo Settore che lavorano nel tuo ambito.
          </p>
          <v-btn color="primary" class="uppercase" to="/signup" large>Crea il tuo account</v-btn>
        </div>
      </v-col>
      <v-col class="col-md-7 col-12 pa-0">
        <!-- <v-card class="mx-auto v-sheet theme--light elevation-24" style="max-width: 90%"> -->
        <div style="max-width: 100%">
          <v-img
            :src="require('@/assets/ama_img.jpg')"
            class="background-position: center center;"
            aspect-ratio="1.8"
          ></v-img>
        </div>
        <!-- </v-card> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AboutSection"
};
</script>

